import React, {useEffect, useRef, useState} from "react";
import './style.css'
import {toast} from "react-toastify";
import logoIcon from '../../../assets/img/logo_vv.png'
import paymentIcon from '../../../assets/img/mohr.png'
import moment from "moment-jalaali";
import Container from "@mui/material/Container";
import Loading from "../../../components/Loading";
import CurrencyFormat from "react-currency-format";
import {Link, useNavigate} from "react-router-dom";
import {Box, Checkbox} from "@mui/material";
import Button from "@mui/material/Button";
import Api from "../../../utils/api";
import {useSelector} from "react-redux";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Hidden from "@mui/material/Hidden";
import PaidIcon from '../../../assets/img/paid.png';
import returned1 from '../../../assets/img/returned_1.png';
import returned2 from '../../../assets/img/returned_2.png';
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import logoPost from '../../../assets/img/logoPost.PNG'
import { useParams } from "react-router-dom";

// let status = []

const Invoice = (props) => {

    const { id } = useParams();
    
    // const printRef = useRef()
    const history = useNavigate();

    const AppStateData = useSelector(state => state);
    const paymentType = useSelector(state => state.authReducer.setting?.order_statuses?.[0]?.children?.[0].children);
    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(true);
    // const [print, setPrint] = useState(null);
    const [newCondition, setNewCondition] = useState({});
    const [step, setStep] = useState(1);
    const [returnToStore, setReturnToStore] = useState({});
    const [stepName, setStepName] = useState("paid");
    const [stepStatus, setStepStatus] = useState([]);
    const [returnedCount, setReturnedCount] = useState(null);
    const [extra_field_value, setExtra_field_value] = useState(null);
    const [transactionToggle, setTransactionToggle] = useState(false);
    const [returnRequest, setReturnRequest] = useState(0);
    const [basket, setBasket] = useState([]);
    // const [count, setCount] = useState("");

    useEffect(() => {
        const orderStatuses = AppStateData.authReducer.setting?.order_statuses;
        if (orderStatuses) {
            let step = [...orderStatuses].sort((a, b) => a.level - b.level);
            setStepStatus(step);
        }
    }, [AppStateData.authReducer.setting]);



    useEffect(() => {

        let c = document.getElementById("canvas");
        let ctx = c && c.getContext("2d");
        if (ctx !== null) {
            ctx.canvas.width = 300;
            ctx.canvas.height = 200;
        }
        let img = new Image();
        img.src = paymentIcon;
        ctx && ctx.drawImage(img, 0, 0);
    }, []);

    useEffect(() => {
        getData()
    }, []);

    const findReturnedStore = (data) => {
        let obj = []

        let list = data?.filter((item) => {
            return +item.return_request === 1
        })
        for (let i = 0 ; i < list?.length ; i++) {
            obj.push({
                "id" : list[i].pt_id,
                "desc" : "item",
                "count" :list[i].count,
                "back_to_store": 0
            })
        }

        setReturnToStore(obj)
    }

    const getData = () => {
        new Api().get('/orders/' + id).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setInvoice(response.order);
                    setStep(response.order.current_level || 1)
                    setReturnedCount(JSON.parse(response.order.basket)?.return_request_count || "0")
                    setReturnRequest(JSON.parse(response.order.basket)?.return_request || "0")
                    findReturnedStore(JSON.parse(response.order.basket))
                    setBasket(JSON.parse(response.order.basket))
                } else {
                    toast.error(response.msg);
                    history('/card');
                }

                setLoading(false);
            }
        })
    }

    const handleCheckReturn = (e,count ,destination) => {
        let object = {...returnToStore}

        if(Array.isArray(returnToStore)) {
            let convertToObject = Object.fromEntries(returnToStore?.map(k => [k.id, {...k}]))
             object = {...convertToObject}
        }

        let index = object[e.target.name]


        if(typeof index !== "undefined" && object[e.target.name]?.id) {

            delete object[e.target.name]

            setReturnToStore({...object})

        } else {
            const modified = {
                [e.target.name] : {
                    "id" : e.target.name,
                    "desc" : "mohandes rahmatpanah",
                    "count" :count,
                    "back_to_store": destination,
                    ...object[e.target.name]
                }
            }
            setReturnToStore({...returnToStore , ...modified})

        }
    }
    const handleCountReturn = (id , count) => {
        const modified = {
            [id] : {
                ...returnToStore[id],
                count:count
            }
        }
        setReturnToStore(prevState => ({...prevState, ...modified}))
    }

    const handleReturn = () => {
         let list = Object.values(returnToStore)?.filter((item) => {
             return item.id
         })
         let obj = {
            "status": 5,
            "condition": "15",
            "products": list,
            "sms": 1
        }
        new Api().post(`/orders/${id}/status` ,obj ,false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);

                } else {
                    toast.error(response.msg);

                }
                setLoading(false);
            }
        })
    }



    const handleChange = (e) => {
        setNewCondition({"status": e.target.name, "condition": e.target.value})
    }

    const handleStep = (name , step) => {
        setStepName(name)
        setStep(step)
    }

    const handlePrint = (value) => {
        let section = document.querySelector(`.${value}`)
        section.classList.add("section-to-print")
        window.print()
        section.classList.remove("section-to-print")
    }

    const handleExtraField = () => {
        return stepStatus?.[step]?.children?.find((item) => {
            return (item.extra_field_title && +newCondition.condition === +item.id)
        })
    }

    const handleStatus = (e) => {
        let obj = {...newCondition }

        if(handleExtraField()) {
            obj.tracking_code = extra_field_value
            obj.sms = "1"
        }


        new Api().post('/orders/' + id + "/status", obj)
            .then((response) => {
                if (response?.status) {
                    toast.success(response?.msg)
                    getData()
                } else {
                    toast.error(response?.msg)
                }
            })
            .catch((errors) => {
                throw errors
            })
    }

    if (loading) {
        return (
            <React.Fragment>
                <Loading/>
            </React.Fragment>
        );
    }

    let product_count = 0;
    let product_weight = 0;


    return (
        <Container>
            {invoice &&
            <React.Fragment>
                <Box>
                    <Stepper elevation={1} alternativeLabel activeStep={+step}>
                        {
                            JSON.parse(invoice?.order_status)?.map((item ,index) => {
                               return(
                                   <Step key={index}>
                                       <StepLabel style={{cursor:"pointer"}} onClick={() => handleStep(item.title , index)}>
                                           <span>{item.name}</span><br/>
                                           <Hidden only={"xs"}><b style={{
                                               position: 'relative',
                                               'top': '10px'
                                           }}>{item.condition}</b></Hidden>
                                       </StepLabel>
                                   </Step>
                               )
                            })
                        }


                    </Stepper>
                    <div className={"condition_section"}>
                        <div>
                            {
                                <TextField
                                select
                                disabled={step === 4 }
                                label="تعیین وضعیت"
                                value={newCondition.condition}
                                variant="outlined"
                                margin='normal'
                                fullWidth
                                defaultValue={15}
                                style={{marginLeft: "10px", width: "150px"}}
                                onChange={handleChange}
                                name={+step + 1}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            >
                                {
                                    stepStatus?.[step]?.children?.map((item, index) => {
                                        return (
                                            <MenuItem value={item.id}>{item.name}</MenuItem>
                                        )
                                    })
                                }
                            </TextField>
                            }
                            {
                                handleExtraField() && step !== 0 &&
                                <TextField
                                    label="کد رهگیری پست"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    value={extra_field_value}
                                    onChange={event => setExtra_field_value(event.target.value)}
                                    style={{marginLeft:"10px" , width:"250px"}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            }
                            {
                                handleExtraField() && step === 0 &&
                                <TextField
                                    select
                                    disabled={step === 4 }
                                    label=" نحوه پرداخت"
                                    value={newCondition.payment_type}
                                    variant="outlined"
                                    margin='normal'
                                    fullWidth
                                    style={{marginLeft: "10px", width: "150px"}}
                                    onChange={(e) => newCondition.payment_type = e.target.value}
                                    name={"payment_type"}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    {
                                        paymentType?.map((item, index) => {
                                            return (
                                                <MenuItem value={item.id}>{item.name}</MenuItem>
                                            )
                                        })
                                    }
                                </TextField>
                            }
                            {
                                step !== 4  &&
                                    <Button onClick={handleStatus} variant={"contained"} size={"large"}
                                            color={"secondary"}>ثبت</Button>
                            }


                        </div>
                        <div onClick={() => {history(-1)}} className={"headline-icon"}>
                            <img src="https://img.icons8.com/material-rounded/24/000000/near-me.png"/>
                        </div>
                    </div>
                </Box>
                <div className={`factor_container`}>
                    <div className={'cart_factor'}>
                        <div className={'factor_header'}>
                            <div className={'factor_header_left'}>
                                <Link to={'/'}>
                                    <img src={logoIcon}/>
                                </Link>
                            </div>
                            <div className={'factor_header_center'}>
                                <h1>دیجی عطار</h1>
                                <span>حواله تحویل کالا</span>
                            </div>
                            <div className={'factor_header_right'}>
                                <div className={'factor_number'}>
                                    <span> شماره سفارش : </span>
                                    <span>{invoice.order_id}</span>
                                </div>
                                <div className={'factor_time'}>
                                    <span>  تاریخ سفارش : </span>
                                    <span>{moment(invoice.created_at, 'YYYY/MM/DD HH:mm').locale('fa').format('jYYYY/jMM/jDD HH:mm')}</span>
                                </div>
                            </div>
                        </div>
                        <div className={'member_information'}>
                            <div className={'member_information_badge'}>اطلاعات کاربر</div>
                            <div className={'member_information_box'}>
                                <div>
                                    <span className={'member_information_box_title'}> نام و نام خانوادگی</span>
                                    <span className={'points'}> : </span>
                                    <span
                                        className={'member_information_box_value'}> {invoice && invoice.reciver_name}  </span>
                                </div>
                                <div>
                                    <span className={'member_information_box_title'}>کد ملی </span>
                                    <span className={'points'}> : </span>
                                    <span
                                        className={'member_information_box_value'}> {invoice && invoice.national_code}</span>
                                </div>
                                <div>
                                    <span className={'member_information_box_title'}> شماره تماس</span>
                                    <span className={'points'}> : </span>
                                    <span
                                        className={'member_information_box_value'}> {invoice && invoice.reciver_mobile}  </span>
                                </div>
                                <div>
                                    <span className={'member_information_box_title'}> دفعات خرید</span>
                                    <span className={'points'}> : </span>
                                    <span
                                        className={'member_information_box_value'}> {(invoice && invoice.purchase_count) ?invoice.purchase_count:0}  </span>
                                </div>
                                <div>
                                    <span className={'member_information_box_title'}>آدرس</span>
                                    <span className={'points'}> : </span>
                                    <span className={'member_information_box_value'}>
                                        {
                                            invoice && JSON.parse(invoice.address_regions).map((item) => {
                                                return (
                                                    item.title + " - "
                                                )
                                            })
                                        }
                                        {invoice && invoice.address_main}
                                    </span>
                                </div>

                                <div>
                                    <span className={'member_information_box_title'}>کد پستی</span>
                                    <span className={'points'}> : </span>
                                    <span
                                        className={'member_information_box_value'}> {invoice && invoice.postal_code}</span>
                                </div>
                            </div>
                        </div>
                         <div  className={"transaction-btn no-print"} onClick={() => setTransactionToggle(!transactionToggle)}>
                             <span>
                                 تاریخچه تراکنش ها
                             </span>
                         </div>
                        {invoice && invoice.transactions && <div className={`factor_table no-print ${transactionToggle ? "show-transaction" :"hide-transaction"}`}>
                            <div className={'condition'}>
                                <div>
                                    <span>تراکنش های مالی</span>
                                </div>
                            </div>
                            <table cellSpacing="0">
                                <thead>
                                <th>شناسه تراکنش</th>
                                <th>مبلغ</th>
                                <th>توضیحات</th>
                                <th>درگاه</th>
                                <th>کد پیگیری</th>
                                <th>وضعیت</th>
                                <th>تاریخ پرداخت</th>
                                </thead>
                                <tbody>
                                {JSON.parse(invoice.transactions).map((item, index) => {
                                    return (
                                        <tr>
                                            <td><Link to={'/transactions/' + item.id}>{item.id}</Link></td>
                                            <td><CurrencyFormat value={item.amount} displayType="text"
                                                                thousandSeparator/></td>
                                            <td>{item.description}</td>
                                            <td>{item?.gateway}</td>
                                            <td>{item.ref_id ? item.ref_id : '-'}</td>
                                            <td><span
                                                className={'transaction-' + item.status}>{AppStateData.transaction?.status?.[item.status]}</span>
                                            </td>
                                            <td>{item.payment_date ? moment(item.payment_date, 'YYYY/MM/DD HH:mm').locale('fa').format('jYYYY/jMM/jDD HH:mm:ss') : '-'}</td>
                                        </tr>
                                    )
                                })
                                }
                                </tbody>
                            </table>
                        </div>}
                        <div className={'factor_table'}>
                            <div className={'condition'}>
                                <div>
                                    <span>کالاهای موجود در فاکتور</span>
                                </div>
                            </div>
                            <table cellSpacing="0">
                                <thead>
                                <th>ردیف</th>
                                <th>کد محصول</th>
                                {
                                    step === 4 &&
                                    <th>مرجوع</th>

                                }
                                <th>محصول</th>
                                <th>تعداد</th>
                                <th>وزن واحد</th>
                                <th>قیمت واحد</th>
                                <th>تخفیف واحد</th>
                                <th>قیمت با تخفیف</th>
                                <th>مالیات کل</th>
                                <th>قیمت کل</th>
                                {
                                    step === 4 &&
                                        <>
                                            <th className={"no-print"}>درخواست مرجوعی</th>
                                            <th className={"no-print"}>عودت به انبار</th>
                                        </>
                                }


                                </thead>
                                <tbody>
                                {invoice && JSON.parse(invoice.basket)?.map((item, index) => {
                                    product_count += item.count;
                                    product_weight += item.weight * item.count;
                                    return (
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{item.code}</td>
                                            {
                                                step === 4 &&
                                                <td>
                                                    <TextField
                                                        variant="outlined"
                                                        margin='dense'
                                                        style={{width: "50px", textAlign: "center"}}
                                                        name='count'
                                                        defaultValue={item.return_request_count}
                                                        value={returnToStore[item.pt_id]?.count}
                                                        onChange={(e) => {
                                                            handleCountReturn(item.pt_id, e.target.value)
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </td>
                                            }
                                            <td>{item.title}</td>
                                            <td>{item.count}</td>
                                            <td>{item.weight}</td>
                                            <td><CurrencyFormat value={item.price} displayType="text"
                                                                thousandSeparator/></td>
                                            <td><CurrencyFormat value={item.discount} displayType="text"
                                                                thousandSeparator/>&nbsp;%
                                            </td>

                                            <td><CurrencyFormat value={item.count * item.off_price} displayType="text"
                                                                thousandSeparator/></td>
                                            <td><CurrencyFormat value={item.count * item.tax} displayType="text"
                                                                thousandSeparator/></td>
                                            <td><CurrencyFormat
                                                value={(item.off_price * item.count + item.count * item.tax)}
                                                displayType="text" thousandSeparator/></td>
                                            {
                                                step === 4 &&
                                                <>
                                                    <td className={"no-print"}>{<Checkbox
                                                        name={item.pt_id}
                                                        defaultChecked={+item.return_request === 1}
                                                        value={returnRequest === 1}
                                                        onChange={(e) => {
                                                            handleCheckReturn(e, item.count, 0)
                                                            setReturnRequest(returnRequest === 1 ? 0 : 1 )
                                                        }}
                                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    />}</td>
                                                    <td className={"no-print"}>{<Checkbox
                                                        name={item.pt_id}
                                                        value={returnToStore}
                                                        onChange={(e) => handleCheckReturn(e , item.count,1)}
                                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    />}</td>
                                                </>
                                            }

                                        </tr>
                                    )
                                })}
                                <tr>
                                    <td colSpan={step === 4 ? 4 : 3}><b>جمع:</b></td>
                                    <td><b>{product_count}</b></td>
                                    <td><b>-</b></td>
                                    <td><b><CurrencyFormat value={invoice.price} displayType="text" thousandSeparator/></b>
                                    </td>
                                    <td>-</td>
                                    <td><b><CurrencyFormat value={invoice.off_price} displayType="text"
                                                           thousandSeparator/></b></td>
                                    <td><b><CurrencyFormat value={invoice.tax} displayType="text"
                                                           thousandSeparator/></b></td>
                                    <td><b><CurrencyFormat value={+invoice.off_price + +invoice.tax} displayType="text"
                                                           thousandSeparator/></b></td>
                                    {
                                        step === 4 &&
                                        <>
                                            <td className={"no-print"}><b>جمع </b></td>
                                            <td className={"no-print"}><b>جمع تایید شده</b></td>
                                        </>
                                    }


                                </tr>
                                <tr>
                                    <td style={{borderLeft: '0'}} colSpan={step === 4 ? 5 : 4}><b>تخفیف خرده فروشی:</b>&nbsp;<span
                                        className={'span-info'}>(پرداخت در پایان دوره)</span></td>
                                    <td style={{borderRight: '0'}} colSpan={5}></td>
                                    <td><b><CurrencyFormat value={invoice?.retail_reward} displayType="text"
                                                           thousandSeparator/></b></td>
                                    {
                                        step === 4 &&
                                        <>
                                            <td className={"no-print"}><b><CurrencyFormat value={invoice?.returned_amount || 0} displayType="text"
                                                                                          thousandSeparator/></b></td>
                                            <td className={"no-print"}><b><CurrencyFormat value={invoice?.confirmed_returned_amount || 0} displayType="text"
                                                                                          thousandSeparator/></b></td>
                                        </>
                                    }

                                </tr>
                                <tr>
                                    <td style={{borderLeft: '0'}} colSpan={step === 4 ? 5 : 4}><b>هزینه ارسال:</b></td>
                                    <td style={{borderRight: '0'}} colSpan={5}></td>
                                    <td><b><CurrencyFormat value={invoice?.post_cost} displayType="text"
                                                           thousandSeparator/></b></td>
                                    {
                                        step === 4 &&
                                        <td className={"no-print"} colSpan={4} rowSpan={2}>
                                            <Button onClick={handleReturn} variant={"contained"} size={"large"}
                                                    color={"secondary"}>ثبت</Button>
                                        </td>
                                    }

                                </tr>
                                <tr>
                                    <td style={{borderLeft: '0'}} colSpan={step === 4 ? 5 : 4}><b>جمع کل:</b></td>
                                    <td style={{borderRight: '0'}} colSpan={5}></td>
                                    <td><b><CurrencyFormat value={invoice.total_pay} displayType="text"
                                                           thousandSeparator/></b></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <b>کلیه قیمت ها موجود در فاکتور براساس تومان میباشد</b>

                    </div>
                    <div id={'canvas'}>
                        <img src={invoice.returned === 1 ? returned1 : ''}/>
                        <img src={invoice.returned === 2 ? returned2 : ''}/>
                        {invoice.returned === 0 && <img src={invoice.paid === 1 ? PaidIcon : ''}/>}
                    </div>
                </div>
                <Box mt={3} mb={3}>
                    <Button onClick={() => {
                        handlePrint("factor_container")
                    }} color={"default"} variant={"contained"}>پرینت فاکتور</Button>
                    <Button onClick={() => {
                        handlePrint("factor-post")
                    }} color={"default"} variant={"contained"}>پرینت پستی</Button>
                </Box>
                <div className={`factor-post`}>
                    <div>
                        <div  className={"one"}>
                            <span className={"factor-post-title"}>فرستنده: عطاری آنلاین دیجی عطار</span>
                            <span className={"factor-post-address"}>تھران - پونک جنوبی - اشرفی اصفھانی - خیابان خوش طینت - پ38</span>
                            <div>
                                <div className={"factor-post-detail"}>
                                <span>
                                    <strong>تلفن : </strong>
                                    <span>02146040453</span>
                                </span>
                                    <span>
                                    <strong>کدپستی : </strong>
                                    <span>1476695648</span>
                                </span>
                                </div>
                                <img src={logoPost}/>
                            </div>
                        </div>
                        <div className={"two"}>
                            <span className={"factor-post-title"}>گیرنده: {invoice && invoice.reciver_name}</span>
                            <span className={"factor-post-address"}>
                              {
                                  invoice && JSON.parse(invoice.address_regions).map((item) => {
                                      return (
                                          item.title + " - "
                                      )
                                  })
                              }
                                {invoice && invoice.address_main}
                        </span>
                            <div>
                                <div className={"factor-post-detail"}>
                                <span>
                                    <strong>تلفن : </strong>
                                    <span>{invoice && invoice.reciver_mobile}</span>
                                </span>
                                    <span>
                                        <strong>کدپستی : </strong>
                                        <span>{invoice && invoice.postal_code}</span>
                                   </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>}
        </Container>

    );

}


export default Invoice;
